const AVAILABLE_LANGS = [
  { id: "en", name: "English" },
  { id: "hi", name: "Hindi" },
  { id: "ru", name: "Russian" },
];

export { AVAILABLE_LANGS };
